import { ResourceCenterPageUrlService } from "./resource-center-page-url-service.js";
import { ResourceCenterApiService } from "./resource-center-api-service.js";
import { ResourceCenterFilterService } from "./resource-center-filter-service.js"
import { ResourceCenterApiUrlService } from "./resource-center-api-url-service.js";
import { ResourceCenterStrings } from "./resource-center-strings.js";
import { ResourceCenterObjectFactory } from "./object-factory.js";

export function init() {

  if(!window.ResourceCenterSettings) {
    return;
  }

  const settings = mergeSettings();
  const pageUrlService = new ResourceCenterPageUrlService();

  const filterService = new ResourceCenterFilterService(settings || {});
  const apiUrlService = new ResourceCenterApiUrlService(settings || {});
  const resourceCenterFactory = new ResourceCenterObjectFactory(settings.ResourceFactorySettings || {});
  const apiService = new ResourceCenterApiService(apiUrlService, filterService, resourceCenterFactory, settings);
  let pager = null;
  const itemsContainer = document.getElementById(settings.ItemsContainer);

  document.addEventListener('DOMContentLoaded', () => {
    const pagerWrapper = document.querySelector(`#${settings.PagerSelector}`);
    if (pagerWrapper && !settings.DisablePaging) {
      pager = new window.biz.Pager(pagerWrapper, {
        callback: (instance, page) => {
          instance.setPage(page);
          pageUrlService.transformSelectionsToQueryParams(page, true, filterService.getSelection());
          apiService.updateGrid(page).then(updatePager);

          if (!pagerWrapper.classList.contains('js-no-scroll')) itemsContainer.scrollIntoView({behavior:"smooth"});
        }
      });
    }

    if(settings.StartSearchWhenThisNumberOfCharsEntered){
      const searchInput = document.querySelector(`#${settings.SearchSelectors.input}`);
      searchInput.addEventListener('keyup', event => searchOnKeyUp(event, settings.StartSearchWhenThisNumberOfCharsEntered), false);
    }
    else{
      const searchBtn = document.querySelector(`#${settings.SearchSelectors.searchButton}`);
      if (searchBtn) {
        searchBtn.addEventListener('submit', search, false);
        searchBtn.addEventListener('reset', function () {
          filterService.populateSearchField("");
          updateState();
        }, false);
      }
    }

    const clearFilters = Array.from(document.querySelectorAll(`.${settings.SearchSelectors.clearFiltersBtn}`));
    if (clearFilters) {
      clearFilters.forEach(clearButton => {
        clearButton.addEventListener('click', onClearButtonClick, false);
      });
    }

    settings.TaxonomySelectors.forEach(selector => {
      const taxonomiesSelection = Array.from(document.querySelectorAll(`.${selector}`));
      if (taxonomiesSelection) {
        taxonomiesSelection.forEach(taxon => {
          taxon.addEventListener("change", updateState, false);
        });
      }
    });

    const languageSelection = Array.from(document.querySelectorAll(`.${settings.LanguageSelector}`));
    if (languageSelection) {
      languageSelection.forEach(lang => {
        lang.addEventListener('change', updateState, false);
      });
    }

    window.addEventListener('popstate', (event) => {
      updateStateFromUrl(false);
    });

    const resourcesLanguage = pageUrlService.getResourcesLanguage();
    filterService.setSelectedLanguage(resourcesLanguage);

    // If url contains query params, parses them and updates grid.
    if (window.location.search.indexOf('?') > -1) {
      updateStateFromUrl(true);
    }
    else {
      updateState();
    }
  });

  function updatePager(newPagerState) {
    if (pager) {
      if (newPagerState.currentPage > newPagerState.totalPagesCount) {
        newPagerState.currentPage = newPagerState.totalPagesCount;
      }

      pager.setTotalItems(newPagerState.totalItemsCount);
      pager.setMaxPages(newPagerState.totalPagesCount);
      pager.setPage(newPagerState.currentPage);
      pager.setPageSize(settings.ODataSettings.PageSize);

      if (pager._maxPages <= 1) {
        pager.empty();
      }
      else {
        pager.render();

        // Temporary fix for the Prev button on page 1.
        if(!pager.hasPrev() && pager.options.prevWrapperClass && document.querySelector(pager.options.prevWrapperClass)){
          pager.wrapper.querySelector('.' + pager.options.prevWrapperClass + ' > a').href = '#';
        }
      }
    }
  }

  function updateStateFromUrl(shouldPushState) {
    filterService.clearSelection(pageUrlService);
    let currentQueryParams = pageUrlService.getCurrentQueryParams();
    filterService.markSelectedItemsBasedOnQueryParams(currentQueryParams);
    updateState(currentQueryParams.get(ResourceCenterStrings.pageKeyName), shouldPushState);
  }

  // Calls the API service and updates the state of all elements.
  function updateState(page = 1, shouldPushState = true) {
    let pageNumber = settings.DisablePaging ? 0 : page;
    if ((pageNumber == null || isNaN(pageNumber) || pageNumber <= 0) && !settings.DisablePaging) {
      pageNumber = 1;
    }
    const currentSelections = filterService.getSelection();
    pageUrlService.transformSelectionsToQueryParams(pageNumber, shouldPushState, currentSelections);
    apiService.updateGrid(pageNumber).then(response => {
      if (response) {
        updatePager(response);

        if (currentSelections.selectedTaxonomies.length || currentSelections.language || currentSelections.searchTerm) {
          const onFilterActivated = new CustomEvent("onFilterActivated", { detail: currentSelections });
          document.dispatchEvent(onFilterActivated);
        }
        else{
          const onFilterDeactivated = new CustomEvent("onFilterDeactivated");
          document.dispatchEvent(onFilterDeactivated);
        }
      }
    }).catch((err) => {
      if (err.message !== "Awaiting last response.") {
        console.log(err.message);
      }
    });
  }

  // Export the function in order to plug in custom functionalities on widget templates.
  window.refreshGrid = updateState;

  // Used for the search box.
  function search(event) {
    event.preventDefault();
    updateState();
  }

  // Clears the selection made by the user and updates the grid.
  function onClearButtonClick(event) {
    event.preventDefault();
    filterService.clearSelection(pageUrlService, false);

    updateState();
  }

  function mergeSettings() {
    let settings = {
      TaxonomiesToExclude: [],
      TaxasToExclude: [],
      ODataSettings: {},
      TaxonomySelectors: [
        "js-taxon",
        "js-contentType"
      ],
      LanguageSelector: "js-resourceLanguage",
      ItemsContainer: "js-articles",
      MissingItemsContainer: "js-no-resources",
      PagerSelector: "js-pager",
      SearchSelectors: {
        input: "js-searchField",
        searchButton: "js-searchButton",
        clearFiltersBtn: "js-clearFilters",
        activeSerchMessageElement: "js-search-active-message",
        activeSearchMessageTermElement: "js-active-serch-term"
      }

    }

    Object.keys(window.ResourceCenterSettings).forEach(function (key) {
      settings[key] = window.ResourceCenterSettings[key];
    });

    return settings;
  }

  function searchOnKeyUp(event, searchStartLengthLimit){
    let valueEntered = event.target.value;
    if(valueEntered.length >= searchStartLengthLimit || valueEntered.length === 0){
      search(event);
    }
  }
}

init();
